// extracted by mini-css-extract-plugin
module.exports = {"desc":"desc__3fY1c","profile":"profile__xz3oD"};